interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const Near = ({ ...props }: IconProps) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_188_27160)">
      <circle
        cx="50"
        cy="50"
        r="50"
        fill="#00EC97"
      />
      <path
        d="M72.1958 80C71.6668 80 71.1314 79.937 70.6086 79.8173C69.16 79.4772 67.8814 78.6899 66.9051 77.5373L29.8824 33.8003C29.6178 33.4854 29.1014 33.6744 29.1014 34.0901V66.2125C29.1014 66.5841 29.5297 66.792 29.8257 66.559L42.2086 56.601C42.7188 56.1916 43.4431 56.2042 43.9407 56.6199C44.4572 57.0545 44.5705 57.804 44.2178 58.3772L32.2569 77.5247C31.2807 78.6773 30.0021 79.4646 28.5534 79.8047C27.2307 80.1134 25.8513 80.0315 24.5601 79.5591C23.2689 79.0867 22.1604 78.2616 21.3542 77.1657C20.4724 75.9689 20 74.5455 20 73.0338V26.9853C20 25.4737 20.4661 24.0439 21.3542 22.8535C22.1604 21.7576 23.2752 20.9325 24.5601 20.4601C25.8513 19.9877 27.2307 19.8995 28.5534 20.2144C30.0021 20.5545 31.2807 21.3419 32.2569 22.4945L69.2859 66.2314C69.5505 66.5464 70.067 66.3574 70.067 65.9417V33.7751C70.067 33.4035 69.6324 33.1957 69.3426 33.4287L56.9282 43.4245C56.4181 43.8339 55.6937 43.8213 55.1961 43.4056C54.6797 42.971 54.5663 42.2215 54.919 41.6483L66.9114 22.463C67.8877 21.3104 69.1663 20.5231 70.6149 20.1829C71.9376 19.8743 73.3233 19.9562 74.6082 20.4286C75.8994 20.901 77.0079 21.7261 77.8141 22.822C78.6959 24.0187 79.1683 25.4422 79.1683 26.9538V73.0464C79.1683 74.5581 78.7022 75.9878 77.8141 77.1783C77.0079 78.2742 75.8931 79.0993 74.6082 79.5717C73.8272 79.8551 73.0147 80 72.1958 80Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_188_27160">
        <rect
          width="100"
          height="100"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
